module.exports = __webpack_public_path__ + "static/img/oprCt_bg_02.99a5dee3.svg";